import envVar from '../../config/envVars';
import authenticationUtils from '../../utils/authenticationUtils';
import httpPost from '../httpClient/httpPost';
import httpPut from '../httpClient/httpPut';

export interface PaymentSchemePayload {
  id: string;
  amount: number;
  paidAmount: number;
}

export interface CancelTransactionsPayload {
  receiptNos: string[];
  remark: string;
  statusChangeDate: string;
}

export interface AdditionalConcessionOrWaiver {
  description: string;
  amount: number;
  status: string;
  type: string;
  appliedOn: string;
  _id: string;
}

export interface ChequeDetailsPayload {
  chequeNo: string;
  bank: string;
  branch: string;
  issueDate: string;
}

export interface ChequeDetailsResponse {
  chequeNo: string;
  issueDate: string;
  bank: string;
  branch: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface FinePayload {
  _id: string;
  particulars: string;
  feePeriod: string;
  academicYear: string;
  chequeBounceFee: number;
  lateFee: number;
  paidLateFee: number;
  pendingLateFee?: number;
  paidChequeBounceFee: number;
  pendingChequeBounceFee?: number;
  dueDays?: number;
  dueMonths?: number;
  additionalConcessionsAndWaivers: AdditionalConcessionOrWaiver[];
  paymentSchemeId: string;
}

export interface SavePaymentPayload {
  paymentDate: string;
  transactionId: string;
  status: string;
  modeOfPayment: string;
  paymentSchemes: PaymentSchemePayload[];
  amount: number;
  remark: string;
  receiptNo: string;
  feeDepositedUpto: string;
  userId: string;
  fines: FinePayload[];
}

const saveChequeDetails = async (
  payload: ChequeDetailsPayload
): Promise<ChequeDetailsResponse> => {
  const response = await httpPost(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/cheques`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );
  return response as unknown as ChequeDetailsResponse;
};

const savePayment = async (payload: SavePaymentPayload): Promise<any> => {
  const response = await httpPost(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/payments`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );
  return response.data;
};

const cancelTransactions = async (
  payload: CancelTransactionsPayload
): Promise<any> => {
  const response = await httpPut(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/transactions/cancel`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );
  return response.data;
};

const paymentsApis = {
  savePayment,
  saveChequeDetails,
  cancelTransactions
};

export default paymentsApis;
